import { render, staticRenderFns } from "./VPaginate.vue?vue&type=template&id=fed98940&scoped=true&lang=pug"
import script from "./VPaginate.vue?vue&type=script&lang=js"
export * from "./VPaginate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed98940",
  null
  
)

export default component.exports